<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('GetCatalogUnit статистика')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'linkConvert'"
    :deleteParams="()=>{}"
    :apiDeleteName="apiDeleteName"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :force-delete="false"
    :force-is-create="false"
    :force-is-edit="false"
    :prefixShow="prefixShow"
    :hasReadOnlyInTable="hasReadOnlyInTable"
    :eventGetParamsGetData="true"
    :trigerReinit="trigerReinit"
    @setTriger="setTriger"
    @setAllParams="event=>allParamsApi=event"
  >

      <div class="col-sm-12">
        <FilterBlockStatistic :filter-list="filterList" :filterData="filterData"  />
      </div>
    <div class="col-sm-4">
      <l-button type="success" wide block @click="loadStatistic()" :disabled="wait">{{
          $t("Скачать")
        }}
      </l-button>

    </div>
  </common-page-table>
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS, GLOBAL_DATE_TIME_FORMAT } from "../../../../constant";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
import FilterBlockStatistic from "../statisticHrFeed/FilterBlockStatistic.vue";
import { nextTick } from 'vue'
import { ApiService } from "@/util/ApiService";
export default {
  name: "StatisticGetCatalogUnitTable",
  components: { CommonPageTable, FilterBlockStatistic },
  props: {
    hasReadOnlyInTable: { type: Boolean, default: true },
    routeField: { type: String, default: "CompanyId" }
  },
  data() {
    return {
      wait: false,
      allParamsApi: null,
      trigerReinit: false,
      dateFrom: "",
      dateTo: "",
      fieldLang: "",
      apiName: API_METHODS.GET_ALL_STATISTIC_GetCatalogUnit,
      apiDeleteName: "",
      filterList: [{
        "code": "dateFrom",
        "name": "Период от",
        "type": "Date",
        "refEntityCode": null,
        "colWidth": 6,
        "subListId": 0,
        "watchAttr": null
      },
        {
          "code": "dateTo",
          "name": "До",
          "type": "Date",
          "refEntityCode": null,
          "colWidth": 6,
          "subListId": 0,
          "watchAttr": null
        }
      ]
    };
  },
  created() {
    this.dateFrom = this.$moment().subtract(1, "month").format("YYYY-MM-DD");
    this.dateTo = this.$moment().format("YYYY-MM-DD");
  },
  computed: {
    paramsGetData() {
      return {
        paramsDop: {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        }
      };
    },
    prefixEdit() {
      return `/statisticGetCatalogUnit`;
    },
    prefixShow() {
      return this.prefixEdit;
    },
    linkCreate() {
      return this.prefixEdit + "/create";
    },
    nameRoleEntity() {
      let role = NAME_OBJECT.StatisticGetCatalogUnit;
      return role;
    }
  },
  methods: {
    async loadStatistic() {
      try{
        this.wait = true;
        console.log(this.allParamsApi);
        const result = await ApiService(API_METHODS.SAVE_STATISTIC, this.allParamsApi);
        const resultByte = result;
        const blob = new Blob([resultByte],  {
          type: "text/plain"
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob, {
          type: "text/plain"
        });
        link.download = `GetCatalogUnitStatistics(${this.dateFrom};${this.dateTo}).csv`;
        link.click();
      } catch (e) {
        console.error(e);

      } finally {
        this.wait = false;
      }


    },
    setTriger(){
      this.trigerReinit = false;
    },
    convertData(dataNow, langNow) {
      let res = convertLangDataToTable(dataNow, langNow, "", false);
      res = res.map(el => {
        return {
          ...el,
          linkConvert: `${el.receiverSystemCode}/${this.dateFrom}/${this.dateTo}`,     // :receiverSystemCode/:dateFrom/:dateTo/show
        };
      });
      return res;
    },
     filterData(val) {
      if(this.dateFrom == val.dateFrom && this.dateTo == val.dateTo) {
        this.trigerReinit = true;
      } else {
        this.dateFrom = val.dateFrom;
        this.dateTo = val.dateTo;
      }
    }
  }
};
</script>
